class FeelingDataPoint {
	static fromArray(timeline, data) {
		let inst = new FeelingDataPoint(timeline);
		inst._id = data.shift();
		inst._level = data.shift();
		inst._time = data.shift() * 1000;
		let feelingId = data.shift();
		inst._feeling = 0 < feelingId ? timeline._feelings[feelingId] : null;

		return inst;
	}
	constructor (timeline) {
		this.timeline = timeline;
		this._id;
		this._level;
		this._time;
		this._feeling = null;

		this._elem = null;
	}
	get id () {return this._id;}
	get time () {return this._time;}
	get level () {return this._level;}
	get elem () {
		if (this._elem === null && this._feeling !== null) {
			this._elem = UI.div('timeline-feeling norm', [
				this.img = UI.img(null, graphicSrc(this._feeling.graphic, AC.GRAPHIC_SML))
			]);
			this._elem.style.backgroundColor = '#' + this._feeling.color;
		}
		return this._elem;
	}
	get hasIcon() {return this._feeling !== null;}
	checkVisible(viewStart, viewEnd) {
		this._elem.style.display = (this.time < viewStart || viewEnd < this.time) ? 'none' : 'block';
	}
    update () {
        this._elem.style.left = this.timeline.timeToOffset(this._time) + 'px';
        this._elem.style.top = (50 - (this._level * (100 / 7))) + '%';
    }
}